import React, { forwardRef, Ref } from 'react';
import { IInputPriceProps, InputPrice } from '@mofid-securities/uikit';

export interface IPriceInputProps extends Omit<IInputPriceProps, 'ref'> {}

const PriceInput = (
  { classNames, ...props }: IPriceInputProps,
  ref: Ref<HTMLInputElement>
): JSX.Element => (
  <InputPrice
    ref={ref}
    autoComplete="off"
    classNames={{
      ...(classNames || {}),
      helperText: `!mb-1.5 !pr-0 ${classNames?.helperText || ''}`,
      inputFooter: `text-xs font-regular text-gray-140 ${
        classNames?.inputFooter || ''
      }`,
    }}
    size="xl"
    isClearable
    {...props}
  />
);

export default forwardRef<HTMLInputElement, IPriceInputProps>(PriceInput);
